import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { SvgService } from '../../services/svg.service';
import { SVG_DEF } from '../../tokens';

type UmbracoSvg = { type: string, imageUrl: string }

@Component({
    selector: 'app-svg',
    templateUrl: './svg.component.html',
    styleUrls: ['./svg.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgComponent implements OnChanges {
    public _use: string;
    public _defs: SafeHtml;
    @Input() role: string = 'img';
    @HostBinding('attr.aria-hidden') private _ariaHidden: string;
    @Input() public set use(use: string | UmbracoSvg) {
        this._use = typeof use === 'string' || use == null ? use as string : use.imageUrl;
        this._defs = this.sanitizer.bypassSecurityTrustHtml(this.defs[this._use]);

        if (this._use != null && this._use?.endsWith('.svg')) {
            const url = this._use;
            const urlSplit = this._use.split('/'),
                newUse = urlSplit[urlSplit.length - 1].replace('.svg', '');
            this._use = newUse;
            if (!this.svgService.contains(newUse)) {
                this.svgService.add(url, newUse);
            }
        }
    }

    constructor(
        @Inject(SVG_DEF) private defs: { [key: string]: string },
        private svgService: SvgService,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        this._setAriaContext()
    }

    private _setAriaContext() {
        if (Guard.not.nullOrEmpty(this.role))
            this._ariaHidden = 'true';
        else
            this._ariaHidden = null;
    }
}
